// extracted by mini-css-extract-plugin
module.exports = {"Section___margined":"ContentSection_Section___margined__EM1zT","Section___centered":"ContentSection_Section___centered__RACiK"};